import axios from 'axios';

//const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5292/'; // Replace with your actual backend URL
const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://testapi.saamitradestar.com/'; 
//const BASE_URL = process.env.REACT_APP_API_URL || 'http://192.168.1.19:81'; 
// const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://ilmsapi.saamitradestar.com/'; 

// Create an Axios instance
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});



api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token"); // same name as login

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Export the default axios instance for custom requests
export default api;
